import React, { useEffect, useState } from 'react';
import { Blok } from '../../interfaces/Blok.interface';
import Col from '../Utils/Col/Col';
import Container from '../Utils/Container/Container';
import Grid from '../Utils/Grid/Grid';
import classNames from 'classnames';

export interface DataWrapperEmbedBlok extends Blok {
  embed_code: string;
  add_padding_bottom: boolean;
}

export interface DataWrapperEmbedProps {
  blok: DataWrapperEmbedBlok;
}

const trustedDomains = ['datawrapper.dwcdn.net']; // List full domain

// Function to check if URL is from a trusted source
const isTrustedSource = (iframeSrc: string): boolean => {
  try {
    const urlObj = new URL(iframeSrc);
    const domain = urlObj.hostname;
    return trustedDomains.includes(domain);
  } catch {
    return false;
  }
};

const DataWrapperEmbed: React.FC<DataWrapperEmbedProps> = ({ blok }) => {
  const [isEmbedTrusted, setEmbedTrusted] = useState(false);

  useEffect(() => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(blok.embed_code, 'text/html');
    const iframe = doc.querySelector('iframe');

    if (iframe && iframe.src) {
      setEmbedTrusted(isTrustedSource(iframe.src));
    }
  }, [blok.embed_code]);

  if (isEmbedTrusted) {
    return (
      <Container
        className={classNames('pt-10', {
          'pb-20': blok.add_padding_bottom,
        })}
      >
        <Grid>
          <Col span={{ lg: 8 }} start={{ lg: 3 }}>
            <div dangerouslySetInnerHTML={{ __html: blok.embed_code }} />
          </Col>
        </Grid>
      </Container>
    );
  } else {
    console.warn('Untrusted embed code source.');
    return null; // Or an alternative UI/feedback for handling untrusted sources
  }
};

export default DataWrapperEmbed;
